module.exports = __webpack_public_path__ + "static/media/PST01@l.889a491b.jpg";